var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.558,
    rx: 21,
    ry: 20.585,
    fill: "#D6F6DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.502 15.677h7.128C25.49 15.68 27 17.16 27 18.985v9.19c1.657 0 3-1.317 3-2.94v-9.452a2.891 2.891 0 0 0-2.664-2.881 49.457 49.457 0 0 0-.673-.05A3.007 3.007 0 0 0 24 11.266h-1.5a3.007 3.007 0 0 0-2.663 1.586c-.225.015-.45.032-.673.05a2.891 2.891 0 0 0-2.662 2.775zm5.998-2.94c-.828 0-1.5.658-1.5 1.47h4.5c0-.812-.672-1.47-1.5-1.47h-1.5z",
    fill: "#66D554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.985c0-1.015.84-1.838 1.875-1.838h9.75c1.035 0 1.875.823 1.875 1.838v11.028c0 1.015-.84 1.838-1.875 1.838h-9.75c-1.036 0-1.875-.823-1.875-1.838V18.985zm3 2.573c0-.406.336-.735.75-.735h.008c.414 0 .75.33.75.735v.008a.743.743 0 0 1-.75.735h-.008a.743.743 0 0 1-.75-.735v-.008zm2.25 0c0-.406.336-.735.75-.735h3.75c.414 0 .75.33.75.735a.743.743 0 0 1-.75.736H18a.743.743 0 0 1-.75-.736zM15 24.5c0-.406.336-.735.75-.735h.008c.414 0 .75.33.75.735v.008a.743.743 0 0 1-.75.735h-.008a.743.743 0 0 1-.75-.736V24.5zm2.25 0c0-.406.336-.735.75-.735h3.75c.414 0 .75.33.75.735a.743.743 0 0 1-.75.735H18a.743.743 0 0 1-.75-.735zM15 27.44c0-.405.336-.734.75-.734h.008c.414 0 .75.329.75.735v.007a.743.743 0 0 1-.75.735h-.008a.743.743 0 0 1-.75-.735v-.007zm2.25 0c0-.405.336-.734.75-.734h3.75c.414 0 .75.329.75.735a.743.743 0 0 1-.75.735H18a.743.743 0 0 1-.75-.735z",
    fill: "#66D554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpNewIcon);
export default __webpack_public_path__ + "static/media/exp-new-icon.d12624a45c7b7b6d0fce0eb86c59f2d1.svg";
export { ForwardRef as ReactComponent };